import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Clock, Settings } from 'lucide-react';

interface WaitForResponseNodeData {
  title?: string;
  timeout?: number;
  variable?: string;
  color?: string;
  tags?: string[];
}

export const WaitForResponseNode = memo(({ data, isConnectable }: NodeProps<WaitForResponseNodeData>) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-pink-200 hover:border-pink-400 transition-colors duration-300">
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="w-3 h-3 bg-pink-500"
      />
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Clock className="h-4 w-4 mr-2" style={{ color: data.color || '#ec4899' }} />
          <div className="text-sm font-medium text-gray-900">
            {data.title || 'Esperar respuesta'}
          </div>
        </div>
        <Settings className="h-4 w-4 text-gray-400" />
      </div>
      <div className="mt-2 text-sm text-gray-600">
        <div>
          {data.timeout 
            ? `Esperar ${data.timeout} segundos` 
            : 'Sin tiempo configurado'}
        </div>
        {data.variable && (
          <div className="mt-1 text-xs text-gray-500">
            Variable: ${data.variable}
          </div>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="default"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-pink-500"
      />
    </div>
  );
});

WaitForResponseNode.displayName = 'WaitForResponseNode';